import { render } from "./BoosterFooter.vue?vue&type=template&id=7106de06&scoped=true&ts=true"
import script from "./BoosterFooter.vue?vue&type=script&lang=ts"
export * from "./BoosterFooter.vue?vue&type=script&lang=ts"

import "./BoosterFooter.vue?vue&type=style&index=0&id=7106de06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7106de06"]])

export default __exports__